import { changeLanguage, DropdownControl } from 'ia-react-core';
import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { StyledDropDown, StyledLabel } from './DropDownLanguage.styles';

export interface DropDownLanguageProps {

}

const DropDownLanguage: FC<DropDownLanguageProps> = () => {
  const { t } = useTranslation('TermsOfUseModal');
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const handleLanguageChange = useCallback(() => {
    dispatch(changeLanguage((i18n.language?.startsWith('fr') ? 'en' : 'fr')));
  }, [dispatch, i18n.language]);

  const languageOptions =
    [
      { label: 'Français', value: 'fr' },
      { label: 'English', value: 'en' },
    ];
  return (
    <>
      <StyledLabel data-testid="languageDropDownLabel">{t('language')}</StyledLabel>
      <StyledDropDown>
        <DropdownControl
          data-testid="languageDropDown"
          required
          name="languageDropDown"
          aria-label={t('language')}
          options={languageOptions}
          defaultValue={i18n?.language?.startsWith('fr') ? 'fr' : 'en'}
          onValueChange={() => handleLanguageChange()}
        />

      </StyledDropDown>
    </>
  );
};

export default DropDownLanguage;
